import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
	const allElements = document.querySelectorAll(".pi-swiper");
	const brakpoints = {
		1024: {
			slidesPerView: 5,
			spaceBetween: 80,
		},
		991: {
			slidesPerView: 4,
			spaceBetween: 50,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 50,
		},
		561: {
			slidesPerView: 2,
			spaceBetween: 40,
		},
	};
	allElements.forEach((slider) => {
		const sliderEl = document.querySelector("." + slider.dataset.id);
		const slidesPerView = parseInt(slider.dataset.slidesPerView, 10);
		const spaceBetween = parseInt(slider.dataset.spaceBetween, 10);
		const paginationEl = slider.dataset.paginationEl;
		const paginationClickable =
			slider.dataset.paginationClickable === "true";

		new Swiper(sliderEl, {
			slidesPerView: slidesPerView,
			spaceBetween: spaceBetween,
			pagination: {
				el: paginationEl,
				clickable: paginationClickable,
			},
			breakpoints: brakpoints,
		});
	});

	const allProviderElements = document.querySelectorAll(
		".pi-provider-swiper"
	);
	allProviderElements.forEach((slider) => {
		const sliderEl = document.querySelector(".swiper-" + slider.dataset.id);
		new Swiper(sliderEl, {
			loop: true,
			autoplay: {
				delay: 2500,
			},
			breakpoints: brakpoints,
		});
	});

	const allTestimonialElements = document.querySelectorAll(
		".pi-testimonial-swiper"
	);
	allTestimonialElements.forEach((slider) => {
		const sliderEl = document.querySelector(".swiper-" + slider.dataset.id);
		new Swiper(sliderEl, {
			navigation: {
				enabled: true,
				nextEl: ".pi-button-next",
				prevEl: ".pi-button-prev",
			},
			autoplay: {
				delay: 3000,
				disableOnInteraction: true,
			},
			breakpoints: {
				1201: {
					direction: "vertical",
					slidesPerView: 1,
				},
				1200: {
					direction: "horizontal",
					slidesPerView: 2,
				},
			},
		});
	});
});
